import styled from 'styled-components'
import theme, {colors} from '../../../styles/theme'
import {Link} from '@mui/material'

export const AssetsBox = styled.div`
  display: flex;
  justify-content: space-between;
  min-height: calc(100vh - 225px);
  padding-bottom: 64px;

  ${theme.breakpoints.down('md')} {
    flex-flow: column;
    min-height: auto;
  }
`

export const LeftBox = styled.div<{$isExpanded: boolean}>`
  width: 35%;
  margin: 24px 0 0 24px;
  width: ${({$isExpanded}) => ($isExpanded ? '35%' : '48px')};
  transition: width 0.3s ease;

  ${theme.breakpoints.down('md')} {
    margin: 0;
    width: auto;
  }
`

export const RightBox = styled.div`
  box-sizing: border-box;
  border: 1px solid #ebeffc;
  background: #fff;
  border-radius: 2px;
  width: 100%;
  margin: 24px 24px 0;
  padding: 32px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);

  ${theme.breakpoints.down('md')} {
    margin: 0;
    margin-top: 64px;
    padding: 16px;
    border: 0;
    border-top: 1px solid #ebeffc;
    border-bottom: 1px solid #ebeffc;
    border-radius: 0;
  }
`

export const IconsBox = styled.div`
  display: flex;
  gap: 16px;

  && img {
    height: 32px;
  }
`

export const ObjectiveText = styled.p`
  margin: 0;
  padding: 0;
  font-size: 16px;
  color: ${colors.bksGray80};
  margin-top: 24px;
`

export const AssetTitle = styled.p`
  margin: 0;
  padding: 0;
  font-size: 24px;
  color: ${colors.bksGray80};
  font-weight: 700;
  margin-top: 24px;
`

export const TimeBox = styled.p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: ${colors.bksGray80};
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 8px;

  && img {
    height: 16px;
  }
`

export const PlayerBox = styled.div`
  margin-top: 24px;

  && video-js {
    border-radius: 8px;
  }
`

export const TranscriptBox = styled.div`
  margin-top: 32px;
`

export const TranscriptTitle = styled.p`
  margin: 0;
  padding: 0;
  font-size: 16px;
  color: ${colors.bksGray80};
  font-weight: 700;
`

export const TranscriptText = styled.p`
  margin: 0;
  padding: 0;
  font-size: 16px;
  color: ${colors.bksGray80};
  margin-top: 16px;

  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`

export const ButtonsBox = styled.div`
  margin-top: 24px;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 16px;
`

export const StyledLink = styled(({...props}) => <Link {...props} />)`
  color: #${colors.blue1};
  font-size: 14px;
  width: 120px;
  display: flex;
  align-items: center;
  gap: 12px;
`
export const LoggedOutBox = styled.div`
  width: 100%;
  box-sizing: border-box;
  color: ${colors.bksGray80};
  font-family: Public Sans;
  height: 50%;
  max-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  gap: 32px;

  && span {
    text-align: center;
  }

  ${theme.breakpoints.down('md')} {
    padding: 80px 20px 0;
    margin-top: 60px;
    height: 100%;
    align-items: center;
    justify-content: normal;
  }
`
